import Layout from './components/layout';
import ErrorBoundary from './components/error/ErrorBoundary';
import ScrollToTop from './components/common/ScrollToTop';
import CookieConsent from './components/common/CookieConsent';
import LocalizationProvider from './context/localization/provider';
import Providers from './context/providers';

type Props = React.ComponentProps<typeof Layout>;

const AppLayout = (props: Props) => {
  return (
    <ErrorBoundary>
      <LocalizationProvider>
        <Providers>
          <ScrollToTop />
          <Layout {...props} />
          <CookieConsent />
        </Providers>
      </LocalizationProvider>
    </ErrorBoundary>
  );
};

export default AppLayout;
